import { MFE_BLOQUE_AUTH } from '~/config/environment';

import type { RemotesConfig } from './types';

export type NameRemotes = 'mfe_bloque_auth';

export const remotes: RemotesConfig = {
  name: 'copilot',
  remotes: [
    {
      name: 'mfe_bloque_auth',
      entry: `${MFE_BLOQUE_AUTH}/mf-manifest.json`,
    },
  ],
};
